<template>
	<!-- Team start -->
	<section class="section" id="services">
		<div class="container">
			<div class="row justify-content-center ">
				<div class="col-lg-12">
					<ul class="nav nav-pills">
						<li class="nav-item">
							<a class="nav-link active" aria-current="page" href="#" data-bs-toggle="tab" data-bs-target="#home-tab-pane">대시보드</a>
						</li>
						<li class="nav-item">
							<a class="nav-link " href="#" id="analytics-tab" data-bs-toggle="tab" data-bs-target="#analytics-tab-pane">성과분석</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" href="#" id="admanager-tab" data-bs-toggle="tab" data-bs-target="#admanager-tab-pane">광고관리</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" href="#" id="keywords-tab" data-bs-toggle="tab" data-bs-target="#keywords-tab-pane">키워드관리</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" href="#" id="bid-tab" data-bs-toggle="tab" data-bs-target="#bid-tab-pane">입찰</a>
						</li>
						<li class="nav-item">
							<a class="nav-link" href="#" id="bid-tab" data-bs-toggle="tab" data-bs-target="#connections-tab-pane">계정연결</a>
						</li>
					</ul>

					<!-- <div class="card mt-3 rounded  border-0 shadow overflow-hidden">
						<div class="card-body"> -->
					<div class="tab-content" id="myTabContent">
						<DashBoard />
						<Manage />
						<Analytics />

						<div class="tab-pane fade" id="keywords-tab-pane" role="tabpanel" aria-labelledby="keywords-tab" tabindex="0">
							<h3>키워드관리</h3>
						</div>
						<div class="tab-pane fade" id="bid-tab-pane" role="tabpanel" aria-labelledby="bid-tab" tabindex="0">
							<h3>입찰</h3>
						</div>

						<Api />
					</div>
					<!-- </div>
					</div> -->
				</div>
			</div>
		</div>
		<!-- end container -->
	</section>
</template>

<script>
import DashBoard from "./naverad/DashBoard.vue";
import Manage from "./naverad/Manage.vue";
import Api from "./naverad/Api.vue";
import Analytics from "./naverad/Analytics.vue";

import Swal from "../../../js/sweetalert2.min.js";
import axios from "axios";
import moment from "moment";
import $ from "jquery";

export default {
	data() {
		return {
			channels: [],
			step: 3
		};
	},
	components: {
		DashBoard,
		Manage,
		Api,
		Analytics
	},
	created() {
		this.getChannels();
	},
	mounted() {},
	methods: {
		async getChannels() {
			const response = await axios.get("/commerce/getChannels");
			if (response.status == 200 && response.data.channels) {
				this.channels = response.data.channels;
			}
		}
	}
};
</script>
<style>
.fr {
	float: right;
	padding: 0;
}
.nlogo-image {
	width: 30px;
	border: 0px;
	padding: 0;
}
.strategy {
	cursor: pointer;
}
.strategy.selected {
	border: 2px solid #3153fa;
}
.min-height770 {
	min-height: 770px;
}
.pointer {
	cursor: pointer;
}
.addedProducts {
	overflow-y: auto;
	max-height: 680px;
}
.w-2 {
	width: 2%;
}
.w-5 {
	width: 5%;
}
.w-6 {
	width: 6%;
}
.w-7 {
	width: 7%;
}
.w-8 {
	width: 8%;
}
.w-10 {
	width: 10%;
}
.w-55 {
	width: 55%;
}
.w-60 {
	width: 60%;
}
.w-65 {
	width: 65%;
}
.w-80 {
	width: 80%;
}

.ad-table thead {
	display: inline-block;
	width: 100%;
}
.ad-table tbody {
	display: inline-block;
	width: 100%;
}
.ad-table tbody {
	max-height: 400px;
	overflow-y: auto;
}
.ad-table thead tr {
	display: inline-table;
	width: 100%;
}
.ad-table tbody tr {
	display: inline-table;
	width: 100%;
}

.exclamationmark {
	width: 16px;
	height: 16px;
}

.switch {
	position: relative;
	display: inline-block;
	width: 54px;
	height: 30px;
}

.switch input {
	display: none;
}

td .slider {
	position: absolute;
	cursor: pointer;
	top: 2px;
	left: 0;
	right: 0;
	bottom: -4px;
	background-color: #ccc;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

td .slider:before {
	position: absolute;
	content: "";
	height: 22px;
	width: 22px;
	left: 3px;
	bottom: 5px;
	background-color: white;
	-webkit-transition: 0.4s;
	transition: 0.4s;
}

input + .slider {
	background-color: #ccc;
	text-align: right;
	padding: 7px 6px;
	font-size: 12px;
	color: #fff;
}

input:checked + .slider {
	background-color: #3153fa;
	text-align: left;
}

input:focus + .slider {
	box-shadow: 0 0 1px #3153fa;
}

input:checked + .slider:before {
	-webkit-transform: translateX(26px);
	-ms-transform: translateX(26px);
	transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
	border-radius: 34px;
}

.slider.round:before {
	border-radius: 50%;
}

.slot {
	background-color: #aaa;
	padding: 0.5rem;
	color: white;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.text-black {
	color: #000;
}
.daterange {
	width: 190px;
}
</style>



// WEBPACK FOOTER //
// src/components/main/NaverAd.vue